import { render, staticRenderFns } from "./LatestSettlementTab.vue?vue&type=template&id=48f3f0aa"
import script from "./LatestSettlementTab.vue?vue&type=script&lang=js"
export * from "./LatestSettlementTab.vue?vue&type=script&lang=js"
import style0 from "./LatestSettlementTab.vue?vue&type=style&index=0&id=48f3f0aa&prod&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports